import { HowItWorksSection } from "./HowItWorksSection";
import { LanguageSwitcher } from "@/i18n";
import { HeroSection } from "./home/HeroSection";
import { SkillsSection } from "./home/SkillsSection";
import { UseCasesSection } from "./home/UseCasesSection";
import { CTASection } from "./home/CTASection";
import { FooterSection } from "./home/FooterSection";

export function HomePage() {
  return (
    <div className="home-page">
      {/* Language Switcher */}
      <div className="page-language-switcher">
        <LanguageSwitcher />
      </div>

      <HeroSection />
      <SkillsSection />
      <HowItWorksSection />
      <UseCasesSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}
